/**
 * Hook to subscribe to system configuration
 * Provides real-time updates for maintenance mode and announcements
 */

import { useState, useEffect } from 'react';
import { adminConfigService, SystemConfig, DEFAULT_CONFIG } from '../services/adminConfigService';

export function useSystemConfig() {
  const [config, setConfig] = useState<SystemConfig>(DEFAULT_CONFIG);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Initial fetch
    adminConfigService.getConfig()
      .then(setConfig)
      .finally(() => setIsLoading(false));

    // Subscribe to real-time updates
    const unsubscribe = adminConfigService.subscribeToConfig((newConfig) => {
      setConfig(newConfig);
    });

    return () => unsubscribe();
  }, []);

  return {
    config,
    isLoading,
    maintenanceMode: config.features.maintenanceMode,
    maintenanceMessage: config.messages.maintenanceMessage,
    announcementBanners: config.messages.announcementBanners,
    announcementDismissible: config.messages.announcementDismissible,
  };
}
